import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleOpenArrowUpLeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M7.5,8.561v2.689c0,.414-.336,.75-.75,.75s-.75-.336-.75-.75V6.75c0-.414,.336-.75,.75-.75h4.5c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75h-2.689l6.599,6.598c1.149-1.385,1.841-3.162,1.841-5.098,0-4.411-3.589-8-8-8S1,4.589,1,9s3.589,8,8,8c1.936,0,3.713-.692,5.099-1.841l-6.599-6.598Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCircleOpenArrowUpLeftFill18.js.map